import { component } from 'picoapp'

export default component((node) => {
  node.addEventListener('click', (event) => {
    event.preventDefault()
    const label = node.dataset.label
    const url = node.href
    const eventName = node.dataset.eventName
    const target = node.dataset.target || '_self'

    if (window.gtag) {
      window.gtag('event', eventName, {
        event_label: label,
        event_callback: function () {
          if (target === '_blank') {
            window.open(url, target)
          } else {
            window.location.href = url
          }
        },
      })
    } else {
      if (target === '_blank') {
        window.open(url, target)
      } else {
        window.location.href = url
      }
    }
  })
})
